import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: 'xena-select',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: XenaDSSelectValueAccessorDirective, multi: true }],
    standalone: false
})
export class XenaDSSelectValueAccessorDirective implements ControlValueAccessor {

  private onTouched: () => void;
  private onChange: (value: object) => void;

  constructor(private element: ElementRef, private renderer: Renderer2) { }

  writeValue(value: object): void {
    this.renderer.setProperty(this.element.nativeElement, 'value', value);
  }

  registerOnChange(fn: (value: object) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  @HostListener('valueChange')
  onValueChange(): void {
    if (this.onChange)
      this.onChange(this.element.nativeElement.value);
  }

  @HostListener('xnBlur')
  onBlur(): void {
    if (this.onTouched)
      this.onTouched();
  }

  setDisabledState(isDisabled: boolean): void {
    this.renderer.setProperty(this.element.nativeElement, 'disabled', isDisabled);
  }
}
